import React, { useState } from "react";
import { Box, styled, Theme, Button } from "@material-ui/core";
import { useInView } from "react-intersection-observer";
import ProductDetailsModule from "./Module";
import { ReportTypography } from "./ModuleOilCoaReport";
import useTranslate from "../../../../../hooks/use-translate";
import { ProductDetailsPageData_datoCmsProduct_variants_variantDetail_coaReport as CoaReport } from "../../../../../templates/ProductDetailsPage/__generated__/ProductDetailsPageData";
import { analyticsTrackEvent } from "../../../../../services/analytics";

const IngredientBar = styled("div")(({ theme }) => ({
  width: "100%",
  height: theme.spacing(0.75),
  borderRadius: "3px",
  background: theme.palette.grey[400],
  display: "flex",
  alignItems: "center",
  overflow: "hidden"
}));

const IngredientBarFilled = styled(({ percentage, active, ...props }) => (
  <div {...props} />
))(
  ({
    theme,
    percentage,
    active
  }: {
    theme: Theme;
    percentage: number;
    active: boolean;
  }) => ({
    width: active ? `${percentage}%` : "0%",
    height: "100%",
    borderRadius: "3px",
    background: theme.palette.primary.main,
    transition: "width ease-in-out 1s"
  })
);

type Props = {
  data: {
    title: string;
    coaReport: CoaReport;
  };
};

const INGREDIENTS_COLLAPSED_COUNT = 6;

const ProductDetailsModuleOilCoaReportIngredients = ({
  data: { title, coaReport }
}: Props) => {
  const t = useTranslate();
  const isLongList = coaReport.ingredients.length > INGREDIENTS_COLLAPSED_COUNT;
  const [isExpanded, setExpanded] = useState<boolean>(false);

  const [ref, inView] = useInView({
    threshold: 0.1,
    triggerOnce: true
  });

  if (
    !coaReport ||
    !coaReport.ingredients ||
    coaReport.ingredients.length === 0
  ) {
    return null;
  }

  return (
    <ProductDetailsModule title={title}>
      <Box
        display="flex"
        flexDirection="column"
        alignItems="stretch"
        // @ts-ignore
        ref={ref}
      >
        {coaReport.ingredients
          .slice(0, isExpanded ? -1 : INGREDIENTS_COLLAPSED_COUNT)
          .map(ingredient => (
            <Box
              key={ingredient.name}
              display="flex"
              flexDirection="column"
              marginBottom={0.5}
            >
              <Box
                display="flex"
                justifyContent="space-between"
                alignItems="center"
              >
                <ReportTypography color="textSecondary">
                  {ingredient.name}
                </ReportTypography>
                <ReportTypography>{ingredient.percentage} %</ReportTypography>
              </Box>
              <IngredientBar>
                <IngredientBarFilled
                  percentage={ingredient.percentage}
                  active={inView}
                />
              </IngredientBar>
            </Box>
          ))}

        {isLongList && (
          <Box
            display="flex"
            justifyContent="center"
            alignItems="center"
            marginTop={2}
          >
            <Button
              variant="text"
              color="primary"
              size="small"
              onClick={() => {
                setExpanded(!isExpanded);
              }}
            >
              {isExpanded
                ? t("pdp.coaReportIngredients.seeLess")
                : t("pdp.coaReportIngredients.seeMore")}
            </Button>
          </Box>
        )}
      </Box>
    </ProductDetailsModule>
  );
};

export default React.memo(ProductDetailsModuleOilCoaReportIngredients);
